import { gql } from '@apollo/client';

const SUBMIT_USER_BENEFIT_REQUEST = gql`
  mutation submitUserBenefitRequest(
    $user_id: String!
    $benefit_type: String!
    $benefit_id: String!
    $benefit_info: JSONObject!
    $amount: Float
    $order: JSONObject
  ) {
    submitUserBenefitRequest(
      user_id: $user_id
      benefit_type: $benefit_type
      benefit_id: $benefit_id
      benefit_info: $benefit_info
      amount: $amount
      order: $order
    ) {
      status
    }
  }
`;

export default SUBMIT_USER_BENEFIT_REQUEST;
